import CurrencyHelper from "../../../../../../../../../common/helpers/currency/CurrencyHelper";
import { IProduct, LabelValue } from "../../../../../../../../../common/types";
import { SortHelper } from "../../../../../../../../../common/helpers/sort/SortHelper";
import { ProductFilterOption } from "../../../../../../../types";
import { Nullable } from "@reedexpo/mercury-badge";

export const mapCompanyFilterValues =
  (products: IProduct[], language: string) =>
  ({ sku, label }): Nullable<LabelValue> => {
    if (sku === "all") {
      return { label, value: sku };
    }
    const product = products.find(pr => sku === pr.sku);
    if (!product) {
      return null;
    }
    const { value, currency } = product.price_range.maximum_price.regular_price;
    return { label: label + " " + CurrencyHelper.moneyFormatWithoutZeros(value, currency, language), value: product.sku };
  };

export const mapAndSortFilterCompanyValues = (options: ProductFilterOption[], products: IProduct[], language: string) => {
  const list = options.map(mapCompanyFilterValues(products, language));
  const filteredList = list.filter(Boolean) as LabelValue[];
  return filteredList.sort((el1, el2) => SortHelper.alphabeticalSort(el1.label, el2.label));
};
